__turbopack_context__.v({
  "buttonDisabled": "FavoriteButton-module-scss-module__asStTG__buttonDisabled",
  "favoriteButton": "FavoriteButton-module-scss-module__asStTG__favoriteButton",
  "favoriteIcon": "FavoriteButton-module-scss-module__asStTG__favoriteIcon",
  "filledIcon": "FavoriteButton-module-scss-module__asStTG__filledIcon",
  "standardButton": "FavoriteButton-module-scss-module__asStTG__standardButton",
  "standardIcon": "FavoriteButton-module-scss-module__asStTG__standardIcon",
});
